// extracted by mini-css-extract-plugin
export default {"innerHtml":"Privacy_innerHtml__Atiy+","header_toolbar":"Privacy_header_toolbar__RAoSe","header":"Privacy_header__IC7Zc","modal":"Privacy_modal__v55Ml","grid":"Privacy_grid__B9mDi"};